"use strict";
exports.__esModule = true;
exports.EXPIRED_INVITATION = exports.MISSING_INVITATION = exports.MISMATCHED_INVITATION_EMAIL = exports.MISMATCHED_ICS_FILES = exports.DOMAIN_DISALLOWED_ERROR = void 0;
exports.DOMAIN_DISALLOWED_ERROR = "1000";
exports.MISMATCHED_ICS_FILES = "1001";
exports.MISMATCHED_INVITATION_EMAIL = "1002";
exports.MISSING_INVITATION = "1003";
exports.EXPIRED_INVITATION = "1004";
//# sourceMappingURL=error-codes.js.map